import { FIRST_CBT_NAMESPACE_ID } from "src/constants";
import { INCOMPLETE, PREQUALIFIED } from "src/services/constants";
import { USER_ONBOARD_ADMIN, USER_ONBOARD_ADMIN_LO, USER_ONBOARD_LOAN_OFFICER, USER_ONBOARD_LOAN_OFFICER_BACK_END, USER_ONBOARD_LOAN_PROCESSOR, USER_ONBOARD_UNDERWRITER } from "src/services/constants/accounts";
import SiteSettings from 'src/siteSetting';

const ADMIN_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 0
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 1
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 6
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 0
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }   
]

const ADMIN_LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 4
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 6
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 5
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 1
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }    
]

const LO_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 1
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }   
]

const LOAN_PROCESSOR_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Funded",
        key: "my_funded",
        order_id: 3,
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 1
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }    
]

const LO_BACKEND_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 1
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }   
]



const UNDERWRITTER_TABS = [
    {
        title: SiteSettings.pipeLineNameForAllApps(),
        key: "all_applications",
        order_id: 1
    },
    {
        title: "My Applications",
        key: "my_applications",
        order_id: 0
    },
    {
        title: "Pending",
        key: "pending",
        order_id: 2
    },
    {
        title: "Approved Not Accepted",
        key: "approved_not_accepted",
        order_id: 3
    },
    {
        title: "Withdrawn",
        key: "withdrawn",
        order_id: 6
    },
    {
        title: "Completed",
        key: "completed",
        order_id: 5
    },
    {
        title: "Declined",
        key: "declined",
        order_id: 4
    },
    {
        title: PREQUALIFIED,
        key: "prequalified",
        order_id: 1
    },
    {
        title: INCOMPLETE,
        key: "incomplete",
        order_id: 8
    }    
]


const namespaceId = FIRST_CBT_NAMESPACE_ID
export const firstcbtPipelineConfig = [{
    namespaceId: namespaceId,
    role: USER_ONBOARD_ADMIN_LO,
    tabs: ADMIN_LO_TABS
},
{
    namespaceId: namespaceId,
    role: USER_ONBOARD_ADMIN,
    tabs: ADMIN_TABS
},
{
    namespaceId: namespaceId,
    role: USER_ONBOARD_LOAN_OFFICER,
    tabs: LO_TABS
},
{
    namespaceId: namespaceId,
    role: USER_ONBOARD_LOAN_PROCESSOR,
    tabs: LOAN_PROCESSOR_TABS
},
{
    namespaceId: namespaceId,
    role: USER_ONBOARD_LOAN_OFFICER_BACK_END,
    tabs: LO_BACKEND_TABS
},
{
    namespaceId: namespaceId,
    role: USER_ONBOARD_UNDERWRITER,
    tabs: UNDERWRITTER_TABS
}];
